import styles from './index.module.scss'
import { useContext, useState, useMemo, useEffect } from 'react'
import { Modal, Segmented, message, ConfigProvider } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { CLOTH_TYPE, IMAGE_TYPE, UPLOAD_SOURCE } from "@utils/CONST";
import { GenerateContext } from "@utils/GenerateContext"
import useResizeObserver from "@utils/useResizeObserver"

const SegmentedCom = (props) => {
    const {
        rightProjectId,
        taskCacheclothType
    } = useContext(GenerateContext)

    const [wrapWidth, setWrapWidth] = useState(0)
    const [wrapHeight, setWrapHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setWrapWidth(entry.contentRect.width)
            setWrapHeight(entry.contentRect.height)
        }
    })

    const sampleVisible = useMemo(() => {
        if (rightProjectId) return false
        if (wrapWidth < 680) {
            return false
        } else return true
    }, [wrapWidth, rightProjectId])

    const [segmentedVal, setSegmentedVal] = useState(CLOTH_TYPE.SUIT)

    useEffect(() => {
        props.clothTypeChange(CLOTH_TYPE.SUIT)
    }, [])


    const segmentedChange = (value) => {
        setSegmentedVal(value)
        props.clothTypeChange(value)
        props.onResetProject()
    }


    useEffect(() => {
        if(!taskCacheclothType) return
        if(taskCacheclothType == 3) {
            setSegmentedVal(CLOTH_TYPE.SKIRT)
            props.clothTypeChange(CLOTH_TYPE.SKIRT)
        } else {
            setSegmentedVal(CLOTH_TYPE.SUIT)
            props.clothTypeChange(CLOTH_TYPE.SUIT)
        }
    }, [taskCacheclothType])

    return (
        <ConfigProvider
            theme={{
                components: {
                    Segmented: {
                        trackBg: 'rgba(227, 227, 246, 1)',
                    },
                },
            }}
        >
            <div className={styles.segmented} ref={targetRef}>
                <div className={styles.SegmentedContent}>
                    <Segmented
                        options={[
                            { label: '组合套装', value: CLOTH_TYPE.SUIT },
                            { label: '连体装', value: CLOTH_TYPE.SKIRT },
                        ]}
                        block
                        value={segmentedVal}
                        onChange={segmentedChange}
                    />
                </div>
                {sampleVisible ? <div className={styles.Placeholder}></div> : ""}
            </div>
        </ConfigProvider>
    )
}

export default SegmentedCom